import { AccessPermissions, getAccessPermissions } from "../../modules/app/acces-rules";
import { ACCESS_PERMISSIONS } from "../actions-constants/accessPermissions.constants";
import { LoggedUser } from "../store";
import { Account } from "@idha/idha-types";

export function setPermissions(permissions:Partial<AccessPermissions>) {
    return {
        type: ACCESS_PERMISSIONS.SET_PERMISSIONS,
        permissions:permissions
    }
}

export function setupPermissions(loggedUser:LoggedUser,account?:Account) {    
    let _loggedUser:LoggedUser = new LoggedUser();

    let permissions = getAccessPermissions(Object.assign(_loggedUser,loggedUser),account);
    
    return {
        type: ACCESS_PERMISSIONS.SET_PERMISSIONS,
        permissions:permissions
    }
}